//日期区间
export const DsfDateIntervalPicker = dsf.defineLazyComponent("DsfDateIntervalPicker", () =>
  require("./dateIntervalPicker.vue")
);
//日期
export const DsfDatePicker = dsf.defineLazyComponent("DsfDatePicker", () =>
  require("./datePicker.vue")
);

//年季度旬
export const DsfPeriodPicker = dsf.defineAsyncComponent("DsfPeriodPicker", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./periodPicker.vue")
);
//年季度旬区间
export const DsfPeriodIntervalPicker = dsf.defineAsyncComponent("DsfPeriodIntervalPicker", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./periodIntervalPicker.vue")
);
//时间
export const DsfTimePicker = dsf.defineAsyncComponent("DsfTimePicker", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./timePicker.vue")
);
//时间区间
export const DsfTimeIntervalPicker = dsf.defineAsyncComponent("DsfTimeIntervalPicker", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./timeIntervalPicker.vue")
);
